"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _ProductKeywords = _interopRequireDefault(require("./ProductKeywords"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    rowInfo: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: 70,
      marginLeft: 18
    },
    chipWrapper: {
      '& > *': {
        margin: theme.spacing(0.5)
      }
    }
  };
});

var ProductInfo = function ProductInfo(_ref) {
  var product = _ref.product,
      ProductKeywordProps = _ref.ProductKeywordProps,
      labels = _ref.labels;
  var classes = useStyles();
  var title = product.title,
      _product$codes = product.codes,
      codes = _product$codes === void 0 ? [] : _product$codes,
      types = product.types,
      validity = product.validity;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.keywords), /*#__PURE__*/_react["default"].createElement(_ProductKeywords["default"], ProductKeywordProps), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.refDocs), /*#__PURE__*/_react["default"].createElement(_core.List, null, codes.map(function (code) {
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, null, /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      key: code,
      primary: code
    }));
  })), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.info.title), /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.rowInfo
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "subtitle2"
  }, labels.info.subTitle), /*#__PURE__*/_react["default"].createElement(_core.Typography, null, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.rowInfo
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "subtitle2"
  }, labels.info.validity), /*#__PURE__*/_react["default"].createElement(_core.Typography, null, validity || 36))), /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.labels), /*#__PURE__*/_react["default"].createElement(_core.List, null, types.map(function (label) {
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
      key: label
    }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, label.key), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      primary: label.title
    }));
  })));
};

ProductInfo.propTypes = {
  className: _propTypes["default"].string,
  labels: _propTypes["default"].object.isRequired,
  product: _propTypes["default"].object.isRequired
};
ProductInfo.defaultProps = {
  className: ''
};
var _default = ProductInfo;
exports["default"] = _default;